import axios from "axios";
import environment from "environment";
import { getCsrfToken } from "utilities/authSession";

const request = async (method, path, data, password) => {
  try {
    const response = await axios({
      method,
      url: `${environment.baseApi}${path}`,
      data,
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCsrfToken(),
        ...(password ? { "X-Admin-Password": password } : {}),
      },
    });
    return response.data.result;
  } catch (err) {
    const error = new Error(
      err?.response?.data?.message || err?.message || "requestFailed"
    );
    error.status = err?.response?.status;
    error.raw = err;
    throw error;
  }
};

const adminUserService = {
  summary: () => request("get", "/admin/summary"),
  invite: (data, password) =>
    request("post", "/admin/invitations", data, password),
  resend: (id, password) =>
    request("post", `/admin/invitations/${id}/resend`, {}, password),
  revoke: (id, password) =>
    request("post", `/admin/invitations/${id}/revoke`, {}, password),
  updateUser: (id, data, password) =>
    request("patch", `/admin/users/${id}`, data, password),
  decideRecovery: (id, decision, reason, password) =>
    request(
      "post",
      `/admin/mfa-recoveries/${id}/${decision}`,
      { reason },
      password
    ),
};

export default adminUserService;
